import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Card, Col, Input, Row, CardBody } from "reactstrap";
import { useNavigate } from 'react-router-dom'
import FloatingInput from '../../components/Input';

import signUpImage from "../../assets/images/auth/sign-up.png";
import { Form } from "react-bootstrap";
import { post } from "../../../src/utils/apiUtil.js"

const SignUp = () => {
    document.title = "Sign Up - Matrix Executive Search Group";
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        fullName: '',
        emailAddress: '',
        phoeNumber: '',
        password: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const response = await post('/sign-up', formData);
            console.log(response)
            if (response?.data?.token) {
                localStorage.setItem('token', response?.data?.token);
            } else {
                throw new Error("Invalid response from server.");
            }
            navigate('/');
        } catch (error) {
            alert(error?.response?.data || "Something went wrong.");
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <React.Fragment>
            <div>
                <div className="main-content">
                    <div className="page-content">
                        <section className="bg-auth">
                            <Container>
                                <Row className="justify-content-center">
                                    <Col xl={10} lg={12}>
                                        <Card className="auth-box">
                                            <Row className="align-items-center">
                                                <Col lg={6} className="text-center">
                                                    <CardBody className="p-4">
                                                        <div className="mt-5">
                                                            <img
                                                                src={signUpImage}
                                                                alt=""
                                                                className="img-fluid"
                                                                draggable="false"
                                                            />
                                                        </div>
                                                    </CardBody>
                                                </Col>
                                                <Col lg={6}>
                                                    <CardBody className="auth-content p-5 text-white">
                                                        <div className="w-100">
                                                            <div className="text-center mb-4">
                                                                <h5>Let's Get Started</h5>
                                                                <p className="text-white-70">
                                                                    Sign up and get access to all the features.
                                                                </p>
                                                            </div>
                                                            <Form action="/" className="auth-form" onSubmit={handleSubmit}>
                                                                <FloatingInput
                                                                    name="fullName"
                                                                    label="Full name"
                                                                    bgType="dark"
                                                                    onChange={handleChange}
                                                                    required
                                                                />

                                                                <FloatingInput
                                                                    name="emailAddress"
                                                                    label="Email address"
                                                                    type="email"
                                                                    bgType="dark"
                                                                    onChange={handleChange}
                                                                    required
                                                                />

                                                                <FloatingInput
                                                                    name="phoneNumber"
                                                                    label="Phone number"
                                                                    type="tel"
                                                                    bgType="dark"
                                                                    onChange={handleChange}
                                                                    required
                                                                />

                                                                <FloatingInput
                                                                    name="password"
                                                                    label="Create your password"
                                                                    type="password"
                                                                    onChange={handleChange}
                                                                    bgType="dark"
                                                                    required
                                                                />
                                                                <div className="mb-4">
                                                                    <div className="form-check">
                                                                        <Input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            name="flexCheckDefault"
                                                                        />
                                                                        <label
                                                                            className="form-check-label"
                                                                            htmlFor="flexCheckDefault"
                                                                        >
                                                                            I agree to the{" "}
                                                                            <Link
                                                                                to="#"
                                                                                className="text-white text-decoration-underline"
                                                                            >
                                                                                Terms and conditions
                                                                            </Link>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div className="text-center">
                                                                    <button
                                                                        type="submit"
                                                                        className="btn btn-white btn-hover w-100"
                                                                    >
                                                                        {isLoading ? "Creating your account" : "Sign up"}
                                                                    </button>
                                                                </div>
                                                            </Form>
                                                            <div className="mt-3 text-center">
                                                                <p className="mb-0 fs-14">
                                                                    Already a member?{" "}
                                                                    <Link
                                                                        to="/sign-in"
                                                                        className="fw-medium text-white text-decoration-underline"
                                                                    >
                                                                        {" "}
                                                                        Click here to sign in
                                                                        {" "}
                                                                    </Link>
                                                                </p>
                                                            </div>
                                                            <div className="mt-1 text-center">
                                                                <p className="mb-0 fs-13">
                                                                    Back to {" "}
                                                                    <Link
                                                                        to="/"
                                                                        className="fw-medium text-white text-decoration-underline"
                                                                    >
                                                                        {" "}
                                                                        Home
                                                                        {" "}
                                                                    </Link>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </CardBody>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default SignUp;
